import "./App.css";
import React from "react";
import "fontsource-work-sans";
import  { BreakpointProvider } from "react-socks";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import ScrollToTop from "./components/multi-page-attributes/ScrollToTop";
import HomePageManager from "./components/home-page/HomePageManager";
import SelectPage from "./components/select-page/SelectPageManager";
import TerminalPageManager from "./components/terminal-page/TerminalPageManager";
import SimplePageManager from "./components/simple-page/SimplePageManager";
import Page404 from "./components/multi-page-attributes/Page404";

function App() {
    document.body.style.backgroundColor = "#FFFFFF"; // "#0F3057"
    document.body.style.fontFamily = "Work Sans";
    document.body.style.color = "#007BFF";

    return (
        <BreakpointProvider>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <ScrollToTop />
                <Switch>
                    <Route exact path="/" render={() => <HomePageManager />} />
                    <Route exact path="/select" render={() => <SelectPage />} />
                    <Route path="/terminal" render={() => <TerminalPageManager />} />
                    <Route path="/about" render={() => <SimplePageManager />} />
                    <Route path="/404" render={() => <Page404 />} />
                    <Redirect to="/404" />
                </Switch>
            </BrowserRouter>
        </BreakpointProvider>
    );
}

export default App;
